export const bannersTypes = [
    {
        name: 'Товар',
        key: 'product',
    },
    {
        name: 'Услуга',
        key: 'service',
    },
    // {
    //     name: 'Категория',
    //     key: 'category',
    // },
    // {
    //     name: 'Сcылка',
    //     key: 'link',
    // },
]